export { default } from './ProductBand';
